import { render, staticRenderFns } from "./DanhSachQuyenKhongThuocNguoiDung.vue?vue&type=template&id=3e77827f&"
import script from "./DanhSachQuyenKhongThuocNguoiDung.vue?vue&type=script&lang=js&"
export * from "./DanhSachQuyenKhongThuocNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports